// extracted by mini-css-extract-plugin
export default {"title-section":"NwmLywtEYW","titleSection":"NwmLywtEYW","not-available":"F5RYySukbY","notAvailable":"F5RYySukbY"};